import React from "react";
import { Badge } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 2,
    top: 2,
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    backgroundColor: "#e00003",
    minWidth: "unset",
    padding: 0,
    border: "none"
  },
}));

const NewBagIcon = ({ size = 22, color = "currentColor", count = 0 }) => (
  <StyledBadge variant="dot" invisible={count === 0} sx={{ mt: 0.5 }}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke={color}
        strokeLinecap="square"
        strokeWidth="1.5"
        d="M7.333 10V6.333A3.667 3.667 0 0 1 11 2.667v0a3.667 3.667 0 0 1 3.667 3.666V10"
      />
      <path
        stroke={color}
        strokeWidth="1.5"
        d="M3.667 7.25h14.666v9.385c0 .761 0 1.142-.236 1.378-.237.237-.617.237-1.379.237H5.282c-.762 0-1.142 0-1.379-.236-.236-.237-.236-.618-.236-1.38V7.25Z"
      />
    </svg>
  </StyledBadge>
);

export default NewBagIcon;
